<template>
    <dropdown-menu
        style="height: 25px;"
        v-bind:show-caret-icon="false">
        <span class="text-right f-s-2" slot="trigger">&bull;&bull;&bull;</span>
        <div>
            <a v-bind:href="memberLink" class="c-primary p-t-2 p-b-2 p-l-4 p-r-4 f-s-3 block h-anim h-bg-accent--light">{{ trans('View Member') }}</a>
        </div>
        <div class="br-top"></div>
        <div>
            <a
                href="#cancel-subscription"
                class="c-error p-t-2 p-b-2 p-l-4 p-r-4 f-s-3 block h-anim h-bg-accent--light"
                v-on:click.prevent="$emit('cancel')"
            >{{ trans('Cancel Subscription') }}</a>
        </div>
    </dropdown-menu>
</template>
<script>
import DropdownMenu from '../DropdownMenu.vue';

export default {
    components: {
        DropdownMenu
    },
    props: {
        memberId: {
            type: String,
            required: true,
        }
    },
    computed: {
        memberLink() {
            return window.Kourses.activeBaseUrl + '/members/' + this.memberId + '/subscriptions';
        },
    },
}
</script>